import { system } from 'styled-system';

import type { ThemeTextDecoration } from '@rover/kibble/styles';

import { createTransformWithDefault } from './transforms';

export type TextDecorationProps = {
  textDecoration?: ThemeTextDecoration;
};
const config = system({
  textDecoration: {
    property: 'textDecoration',
    scale: 'textDecoration',
    transform: createTransformWithDefault('none'),
  },
});
export default config;



// WEBPACK FOOTER //
// ../kibble/styles/styled-system/textDecoration.ts